import { render } from "./PodImages.vue?vue&type=template&id=48308f0b&scoped=true"
import script from "./PodImages.vue?vue&type=script&lang=js"
export * from "./PodImages.vue?vue&type=script&lang=js"

import "./PodImages.vue?vue&type=style&index=0&id=48308f0b&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48308f0b"]])

export default __exports__